import { AxiosPromise } from "axios";
import { axiosInstance } from "../instance";
import { ChannelsRequest, ChannelsResponse } from "./types";

export const getChannels = (params?: ChannelsRequest): AxiosPromise<ChannelsResponse> =>
  axiosInstance.get(`/channels`, { params: {...params, expand: "departments", main: params?.main ?? true} });